<template lang="pug">
  .component.component-backoffice-deposit-configuration
    .field(v-for="(validation, label) in validations")
      .column
        input(:id="`${_uid}-${label}`", v-model="validation.active" type="checkbox")
        label(:for="`${_uid}-${label}`") {{label}}
      .column
        input(type="text", :id="`${_uid}-${label}`", v-if="label === 'default' && validation.active" , placeholder="default", v-model="validation.value")
        input(type="text", :id="`${_uid}-${label}`", v-if="label === 'custom' && validation.active" , placeholder="custom validation", v-model="validation.value")


</template>

<script>
  export default {
    name: 'ValidationConfig',
    data() {
      return {
        validations: {
          string: {
            active: false,
            disabled: false,
          },
          required: {
            active: false,
            disabled: false,
          },
          hidden: {
            active: false,
            disabled: false,
          },
          nullable: {
            active: false,
            disabled: false,
          },
          email: {
            active: false,
            disabled: false,
          },
          default: {
            active: false,
            disabled: false,
            value: null
          },
          custom: {
            active: false,
            disabled: false,
            value: null
          },
        },
      }
    },
    mounted() {
      var arr = []
      if (this.value[this.validationKey] !== null && this.value[this.validationKey].length) {
        this.value[this.validationKey].split('|').forEach((item, k) => {
          if (this.validations.hasOwnProperty(item)) {
            this.validations[item].active = true
          } else {
            this.validations.custom.active = true
            arr.push(item)
          }
        })
        this.validations.custom.value = arr.join('|')
      }

      if (this.value.hasOwnProperty('default') && this.value.default !== null) {
        this.validations.default.active = true
        this.validations.default.value = this.value.default
      }
    },
    watch: {
      validations: {
        handler() {

          let validations = []
          for (var item in this.validations) {

            if (this.validations[item].active && item !== 'default' && item !== 'custom') {
              validations.push(item)
            }

            if (item === 'default' && this.validations.default.active) {
              if (this.validations.default.value !== null) {
                validations.push(`default:${this.validations.default.value}`)
              }
            }


            if (item === 'custom' && this.validations.custom.active && this.validations.custom.value) {
              validations.push(this.validations.custom.value)
            }
          }

          this.$set(this.value, this.validationKey, validations.join('|'))
        },
        deep: true
      },
    },
    props: {
      value: {
        type: Object | Array
      },
      valueKey: String,
      validationKey: String,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ValidationConfig.vue?ca502272